import React, { useEffect, useRef, useState, useMemo } from "react";
import { Upload } from 'antd';
import { PullToRefresh, Tabs, InfiniteScroll, Form, Card, Radio, Space, TextArea, Button, Popup, Toast, Result, Modal, Ellipsis, Image  } from "antd-mobile";
import { RightOutlined, CalendarOutlined, UploadOutlined } from "@ant-design/icons";
import { DownlandOutline,FileOutline } from 'antd-mobile-icons'
import {  useSearchParams } from 'react-router-dom';
import { getFeedbackList, getDictionaryList, createFeedback, getFeedbackDetails } from "../../apis/commonApi";
import { formatFeedbackParam as getParams} from "../../utils";
import { getToken, BASE_DOWNLOAD_URL } from "../../utils/token";
import "./index.scss";


const TabsList = [
  { title:'我要反馈', key:'form' },
  { title:'反馈历史', key:'list' },
];


const InitalForm = {
  feedbackSys:'',
  feedbackTypeCode:'', //意见反馈类型编码
  feedbackTypeName:'', //意见反馈类型名称
  feedbackDescribe:'', //意见反馈详细描述
  sfaFeedbackFileEntity:[], //附件
  submitUserCode:'',
  submitUserName:'',
  feedbackSysTerminal:''
};

const FeedbackDetail = (props) => {
  const { detail } = props || {};
  const [ fileList, setFileList ] = useState([]);

  useEffect(()=>{
    if(!detail) return
    getFeedbackDetails(detail?.id).then(res=>{
      let list = (res?.sfaFeedbackFileEntity || []).map((item) => {
        const reg = /\.(jpg|jpeg|png|gif|bmp|tiff|webp|svg)$/i;
        const isImg = reg.test(item.originalFileName);
        return {
          isImg,
          name: item.originalFileName,
          status: "done",
          url: `${BASE_DOWNLOAD_URL}${item.fileCode}.id`,
          }
      })
      setFileList(list)
    })
    
  },[detail])

  return(
    <>
      <Card className='feed-card feed-card-detail' title="反馈模块" bodyClassName="feed-card-body">
        <div className="feed-detail">{detail?.feedbackTypeName}</div>
      </Card>
      <Card className='feed-card feed-card-detail' title="反馈详情" bodyClassName="feed-card-body">
        <div className="feed-detail">{detail?.feedbackDescribe}</div>
      </Card>
      {!!(fileList && fileList.length) && <Card className='feed-card feed-card-detail' title="上传文件" bodyClassName="feed-card-body">
        <div className="feed-detail">
          {fileList.map(v=><div key={v?.id} className="feed-detail-file">
            <div>{v?.isImg?<Image src={v?.url} width={30} height={30} fit='cover' />:<FileOutline color="#1677ff" fontSize={25} />}</div>
            <div className="feed-detail-center"><Ellipsis direction='middle' content={v.name} /></div>
            <a href={v?.url} download={v?.name} className="feed-detail-icon"><DownlandOutline fontSize={20} /></a>
          </div>)}
        </div>
      </Card>}
    </>
  )

}


const FeedbackForm = (props) => {
  const { disabled=false, detail } = props || {};
  const [ params ] = useSearchParams();
  const [ typeList, setTypeList ] = useState([]);
  const [ fileList, setFileList ] = useState([]);
  const [form] = Form.useForm();
  const userInfo = useRef({sysTerminal:'CRM后台系统',sys:'CRM'});
  const [ jwt, setJwt ] = useState(null);
  const handler = useRef(null);

  const getDict = () => {
    const { sys } = userInfo.current;
    getDictionaryList({ dictTypeCodeList: ["feedback_question_type"] }).then(res=>{
      let questionType = res?.feedback_question_type || [];
      let { children=[] } = questionType.find(v=>v.dictCode == sys) || {};
      setTypeList([...children]);
    })
  }

  const getUploadToken = () => {
    if(userInfo.current.token) return Promise.resolve(userInfo.current.token)
    return getToken().then(res=>{
      userInfo.current.token = res?.data?.jwt;
      return res?.data?.jwt
    })
  }


  // const upLoadFile = async(file) => {
  //   try {
  //     let result = await getOssKey();
  //     let client = new OSS({
  //       region: 'oss-cn-shanghai', // 例如 oss-cn-hangzhou
  //       accessKeyId: '',
  //       accessKeySecret: '',
  //       stsToken:result.securityToken,
  //       bucket: 'yd-crm-test-oss',
  //       ...result
  //     });
  //     let filename = 'example/' + file.name;

  //     let { res } = await client.multipartUpload(filename, file, {
  //       headers: {
  //         'x-oss-object-acl': 'public-read', // 设置文件为公共读权限
  //       },
  //       meta: {
  //         'Content-Type': file.type,
  //       }
  //     })
  //     let urls = (res?.requestUrls || []).map(url=>url.replace('https://yd-crm-test-oss.oss-cn-shanghai.aliyuncs.com','https://crmtestoss.yingde.com'));
  //     return {url:urls[0]}
      
  //   } catch (error) {
      
  //   }
  // }
  
  const uploadProps = useMemo(
    () => ({
      name: "file",
      maxCount: 5,
      multiple: true,
      action: "/crm-venus/v1/venus/files/fileUpload/default",
      headers: {jwt, },
      onChange(info) {
        console.log(info.fileList);
        setFileList(info.fileList)
        // setFileList(info.fileList);
        if (info.file.status !== "uploading") {
        }
        if (info.file.status === "done") {
          console.log(info.file.name);
          // message.success(`${info.file.name} 附件上传成功`);
        } else if (info.file.status === "error") {
          // message.error(`${info.file.name} 附件上传失败`);
        }
      }
    }),
    [jwt]
  );


  const onFinish = () => {
    const { sys:feedbackSys,sysTerminal:feedbackSysTerminal,userCode:submitUserCode,userName:submitUserName } = userInfo.current;
    let formData = {
      feedbackSys,
      feedbackSysTerminal,
      submitUserCode,
      submitUserName,
      ...form.getFieldsValue()
    }
    if(!formData.feedbackTypeCode || !formData.feedbackDescribe) return
    if(handler.current) return
    handler.current =  Toast.show({ icon: 'loading', content: '' });
    const sfaFeedbackFileEntity = fileList.reduce((cur,nxt)=>{
      let result = (nxt?.response?.data || []).map(item=>({
        createTime: item.createTime,
        fileName: item.fileName,
        // id: item.id,
        fileCode:item.id,
        modifyTime: item.modifyTime,
        originalFileName: item.originalFileName,
        relativeLocal: item.relativeLocal,
      }));
      cur = [...cur,...result];
      return cur
    },[]);
    let feedbackTypeName = typeList.find(v=>v.dictCode == formData.feedbackTypeCode)?.dictValue || '';
    createFeedback({...formData,feedbackTypeName,sfaFeedbackFileEntity}).then(res=>{
      setFileList([]);
      form.resetFields();
      Modal.show({
        content:<Result status='success' title='意见反馈提交成功'  description='您反馈的意见已提交，我们将尽快安排解决' />,
        closeOnAction: true,
        actions: [
          {
            key:'complete',
            primary:true,
            text:'确定'
          }
        ]
      })
    }).finally(_=>{
      handler.current?.close();
      handler.current = null;
    })
  
  }

  const initStart = async() => {
    const code = params.get('code');
    userInfo.current = {...userInfo.current,...getParams(code)};
    getDict();
    let jwt = await getUploadToken();
    setJwt(jwt);
  }

  useEffect(()=>{
    if(!detail) return
    getFeedbackDetails(detail?.id).then(res=>{
      let list = (res?.sfaFeedbackFileEntity || []).map((item) => ({
        name: item.originalFileName,
        status: "done",
        url: `${BASE_DOWNLOAD_URL}${item.fileCode}.id`,
      }))
      setFileList(list)
    })
    
  },[detail])

  useEffect(()=>{
   initStart()
  },[])

  return(
    <Form
      form={form}
      initialValues={detail?{...InitalForm,...detail}:{...InitalForm}}
      // onFinish={onFinish}
      disabled={disabled}
      className="feed-form"
      footer={
        disabled?<></>:<Button block type='submit' onClick={onFinish} color='primary' size='large'>提交</Button>
      }
    >
      <Card className='feed-card' bodyClassName="feed-card-body">
        <Form.Item
          name='feedbackTypeCode'
          label='反馈模块：'
          rules={[{ required: true, message: '请选择反馈模块'  }]}
        >
          <Radio.Group
          >
            <Space direction='vertical' className='feed-card-space'>
              {typeList.map(v=>(
                <Radio key={v.dictCode} value={v.dictCode}>{v.dictValue}</Radio>
              ))}
            </Space>
          </Radio.Group>
        </Form.Item>
      </Card>
      <Card className='feed-card' bodyClassName="feed-card-body">
        <Form.Item
            name='feedbackDescribe'
            label='请详细描述您想要反馈的意见：'
            rules={[{ required: true, message: '反馈意见描述不能为空' }]}
          >
            <TextArea
              className="feed-area"
              placeholder='请输入内容'
              maxLength={200}
              autoSize={{minRows:6,maxRows:10}}
            ></TextArea>
          </Form.Item>
      </Card>
      <Card className='feed-card feed-file-card' bodyClassName="feed-card-body">
        <Form.Item
          name='sfaFeedbackFileEntity'
          label='补充上传截图或附件'
          >
            {/* <ImageUploader
              value={form.getFieldValue('sfaFeedbackFileEntity')}
              onChange={changeList}
              upload={upLoadFile}
            /> */}
            <Upload
              action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
              listType="picture"
              fileList={fileList}
              {...uploadProps}
            >
              {!detail && <Button type="primary" >
                <Space>
                  <UploadOutlined />
                  <span>上传文件</span>
                </Space>
              </Button>}
            </Upload>
          </Form.Item>
      </Card>
    </Form>
  )
};

const FeedbackList = () => {
  const [ dataList, setDataList ] = useState([]);
  const [ hasMore, setHasMore ] = useState(true);
  const [ search, setSearch ] = useState({size:10,page:1});
  const [ visibleInfo, setVsibleInfo ] = useState(false);
  const [ params ] = useSearchParams();
  const query = useRef({total:1});

  const loadMore = async() => {
    const code = params.get('code');
    query.current = {...query.current,...getParams(code)};
    return getList(search)
  }

  const clickCard = (item) => {
    console.log(item)
    setVsibleInfo({...item})
  }

  const refreshList = () => {
    let data = {...search,page:1};
    setSearch({...data});
    getList(data)
  }

  const getList = (searchData) => {
    const { userCode:submitUserCode,sys:feedbackSys } = query.current || {};
    setHasMore(false)
    return getFeedbackList({...searchData,submitUserCode,feedbackSys}).then(res=>{
      let list = res?.records || [];
      setDataList(searchData.page == 1?[...list]:[...dataList,...list]);
      query.current.total = res?.pages || 1;
      setHasMore(query.current.total>searchData.page);
      setSearch({...search,page:searchData.page+1});
      return res
    })
  }


  return(
    <>
      <PullToRefresh onRefresh={refreshList}>
        {dataList.map((item) => (
          <Card 
            className="list-card" 
            key={item.id}
            onClick={()=>{clickCard(item)}}
            extra={<RightOutlined style={{color:'#ccc'}} />}
            title={
              <div className="list-card-title">
                <CalendarOutlined style={{color:'#004098'}} />
                <span className="title-name">{item?.submitDate || '---'}</span>
              </div>
            }
          >
            <div className="list-card-content">
              <div className="content-line">
                <div className="content-line-title">反馈模块：</div>
                <div className="content-line-body">{item?.feedbackTypeName || '---'}</div>
              </div>
              <div className="content-line">
                <div className="content-line-title">反馈人工号:</div>
                <div className="content-line-body">{item?.submitUserCode || '---'}</div>
              </div>
              <div className="content-line">
                <div className="content-line-title">反馈人姓名:</div>
                <div className="content-line-body">{item?.submitUserName || '---'}</div>
              </div>
            </div>
          </Card>
        ))}
        <InfiniteScroll loadMore={loadMore} hasMore={hasMore} />
      </PullToRefresh>
      <Popup
        visible={!!visibleInfo}
        onClose={()=>{setVsibleInfo(false)}}
        onMaskClick={()=>{setVsibleInfo(false)}}
        bodyStyle={{ maxHeight: '70vh',overflowY:'auto' }}
      >
        <FeedbackDetail detail={visibleInfo} disabled={true}></FeedbackDetail>
      </Popup>
    </>
  )
};

const FeedbackH5 = () => {
  const [ activeTab, setActiveTab ] = useState('form');

  const changeTabs = (e) => {
    setActiveTab(e)
  }

  useEffect(()=>{
  
  },[])

  return (
    <div className="page-contain">
      <div className="page-head">
        <Tabs onChange={changeTabs} activeKey={activeTab} >
          {TabsList.map(v=>(
            <Tabs.Tab  title={v?.title} key={v?.key}></Tabs.Tab>
          ))}
        </Tabs>
      </div>
      <div className="page-main">
        {
          {
            form:<FeedbackForm />,
            list:<FeedbackList />
          }[activeTab || 'form']
        }
      </div>
    </div>
  );
};

export default FeedbackH5;
